import { render, staticRenderFns } from "./OutboundList.vue?vue&type=template&id=58ffb4d8&scoped=true"
import script from "./OutboundList.vue?vue&type=script&lang=js"
export * from "./OutboundList.vue?vue&type=script&lang=js"
import style0 from "./OutboundList.vue?vue&type=style&index=0&id=58ffb4d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ffb4d8",
  null
  
)

export default component.exports